export default Object.freeze({
  Percentage: 1,
  FixedAmount: 2,
});
